import store from 'store';
import translation from 'translation';

import {BIDDABLE_TYPES as YANDEX_BIDDABLE_TYPES} from './yandex';
import {BIDDABLE_TYPES as GOOGLE_BIDDABLE_TYPES} from './google';
import {BIDDABLE_TYPES as OZON_BIDDABLE_TYPES} from './ozon';

import {setDefaultsForZonesAndDeleteOthers, isNeedToSetZonesWb} from 'store/modules/bidmanager/utils/area-utils';

import {
  BIDDABLE_TYPES,
  nameGenerators as commonNameGenerator,
  STRATEGY_TYPES
} from 'store/modules/bidmanager/utils/common';

export const YANDEX = () => store.getters['channels/getChannelByName']('yandex').id;
export const GOOGLE = () => store.getters['channels/getChannelByName']('google').id;
export const OZON = () => store.getters['channels/getChannelByName']('ozon').id;
export const WILDBERRIES = () => store.getters['channels/getChannelByName']('wildberries').id;

export function getBiddableTypes (channelId) {
  const yandex = YANDEX();
  const google = GOOGLE();
  const ozon = OZON();

  let types = [];

  switch (channelId) {
  case yandex:
    types = YANDEX_BIDDABLE_TYPES;
    break;
  case google:
    types = GOOGLE_BIDDABLE_TYPES;
    break;
  case ozon:
    types = OZON_BIDDABLE_TYPES;
    break;
  default:
    types = [];
    break;
  }

  return types.map(type => ({
    ...type,
    name: type.name(),
    description: type.description()
  }));
}


export function setDefaultName (params, placementType) {
  const rulesLength = params.rules.length;
  if (!rulesLength) {
    return '';
  }

  const action = params.rules[0].action;
  if (action.type) {
    const isManualStrategy = store.getters['bidmanager/isManualStrategy'];
    let name = commonNameGenerator({action, params, placementType, isManualStrategy})[action.type]();

    if (rulesLength > 1) {
      const text = translation.ngettext('and %d rule more', 'and %d rules more', rulesLength - 1);
      name += ` ${text}`;
    }

    return name;
  }
}


export function defaultCondition (channelId, dateframe) {
  return {
    field: 'clicks',
    operator: 'gt',
    values: [0],
    dateframe: dateframe || 'ONE_MONTH'
  };
}


export function defaultRule (channelId, biddableType, uid) {
  return {
    enabled: true,
    conditions: [defaultCondition(channelId)],
    action: biddableType === BIDDABLE_TYPES.PLACEMENT_URL.id ? {type: 'pause_biddable'} : {},
    uid
  };
}

export function getStrategyType (group) {
  return !group.autostrategy_id ? STRATEGY_TYPES.MANUAL : STRATEGY_TYPES.AUTO;
}


export function defaultValuesForAction ({
  action, positionsChoices, channelId, placementType = null, isManualStrategy = false
}) {
  const googleId = GOOGLE();
  const isNeedToSetZones = isNeedToSetZonesWb({placementType, channelId, isManualStrategy});

  let defaults = {};

  // we construct new action, so we could mutate it without lose reactivity
  if (
    action.type === 'increase_bid' ||
    action.type === 'decrease_bid'
  ) {
    const relative_type = action.delta ? action.relative_type || 'percent' : 'percent';
    defaults = {relative_type, delta: action.delta || 0};
    if (defaults.relative_type === 'percent' && defaults.delta > 100) {
      defaults.delta = 0;
    }
    if (action.type === 'increase_bid') {
      if (isNeedToSetZones) {
        setDefaultsForZonesAndDeleteOthers(defaults, action, action.type);
      } else {
        defaults.max_bid = 0;
      }
    } else if (action.type === 'decrease_bid') {
      if (isNeedToSetZones) {
        setDefaultsForZonesAndDeleteOthers(defaults, action, action.type);
      } else {
        defaults.min_bid = 0;
      }
    }
    defaults.limit_relative_type = 'currency';
  } else if (
    action.type === 'bid_above_competitor' ||
    action.type === 'bid_below_competitor'
  ) {
    defaults = {relative_type: action.relative_type || 'percent', delta: action.delta || 0};
    if (defaults.relative_type === 'percent' && defaults.delta > 100) {
      defaults.delta = 0;
    }
    if (action.type === 'bid_below_competitor') {
      defaults.max_bid = action.max_bid || 0;
    } else {
      defaults.min_bid = action.min_bid || 0;
    }
    defaults.limit_relative_type = 'currency';
  } else if (action.type === 'bid_to_traffic_volume') {
    defaults = {traffic_volume: 0, increase_percent: 0, max_bid: 0};
  } else if (action.type === 'bid_to_position') {
    defaults = {position: action.position || positionsChoices[0].id, max_bid: 0, increase_percent: 0};
    if (channelId === googleId) {
      defaults.min_bid = 0;
    }
  } if (action.type === 'bid_position_for_search_cluster') {
    defaults = {min_position: 1, max_position: 100, query: '', exclusive_queries: [], exclusive_queries_enabled: false};

    if (isNeedToSetZones) {
      setDefaultsForZonesAndDeleteOthers(defaults, action, action.type);
    } else {
      defaults.max_bid = 0;
    }
  } else if (
    action.type === 'bid_fixed_value' ||
    action.type === 'set_bid'
  ) {
    if (isNeedToSetZones) {
      setDefaultsForZonesAndDeleteOthers(defaults, action, action.type);
    } else {
      defaults.bid = defaults.bid || 0;
      defaults.relative_type = 'currency';
    }
  } else if (action.type === 'set_min_bid') {
    if (isNeedToSetZones) {
      setDefaultsForZonesAndDeleteOthers(defaults, action, action.type);
    }
  }

  Object.keys(defaults).forEach((key) => {
    action[key] = defaults[key];
  });
}
